import uuidv1 from 'uuid/v1'

var Token = (function() {

    var encounterToken = '';
  
    var getToken = function() {
      return encounterToken;    // Or pull this from cookie/localStorage
    };
  
    var setToken = function() {
      encounterToken = uuidv1();     
      //
    };
  
    return {
        getToken: getToken,
        setToken: setToken
    }
  
  })();
  
  export default Token;